import { useMarketingConsent } from '@/hooks/useMarketingConsent';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';

export function CookieConsentBanner() {
  const { decided, accept, decline } = useMarketingConsent();
  const { t } = useTranslation();

  if (decided) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9999] p-4 pointer-events-none">
      <div className="pointer-events-auto mx-auto max-w-lg rounded-xl border border-border bg-background/95 backdrop-blur-md shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Cookie className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-sm text-muted-foreground leading-relaxed flex-1">
          {t('cookie_banner_text')}{' '}
          <a href="/privacy" className="underline underline-offset-2 text-foreground hover:text-primary transition-colors">
            {t('cookie_privacy_policy')}
          </a>
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <Button variant="ghost" size="sm" onClick={decline} className="flex-1 sm:flex-none">
            {t('cookie_decline')}
          </Button>
          <Button size="sm" onClick={accept} className="flex-1 sm:flex-none">
            {t('cookie_accept')}
          </Button>
        </div>
      </div>
    </div>
  );
}
